import api from "../services/api";

export const postMessageToNativeApp = (message) => {
  if (window.appInterface?.postMessage) {
    window.appInterface.postMessage(message);
    return true;
  }

  if (window.webkit?.messageHandlers?.appInterface?.postMessage) {
    window.webkit.messageHandlers.appInterface.postMessage(message);
    return true;
  }

  return false;
};

export const isNativeApp = () =>
  Boolean(
    window.appInterface?.postMessage ||
      window.webkit?.messageHandlers?.appInterface?.postMessage
  );

export const registerFcmTokenWithBackend = async (token) => {
  if (!token) return;

  await api.post("/auth/fcm-token", { token });
};

export const setupNativeAppBridge = () => {
  window.updateNotificationToken = async function updateNotificationToken(token) {
    try {
      await registerFcmTokenWithBackend(token);
      console.log("[FCM] Token guardado en backend CRM");
    } catch (err) {
      console.error("[FCM] Error guardando token en backend:", err);
    }
  };

  window.handleLoginToken = async function handleLoginToken(token) {
    if (!token) return;

    localStorage.setItem("rememberMe", "true");
    localStorage.setItem("token", JSON.stringify(token));
    api.defaults.headers.Authorization = `Bearer ${token}`;

    try {
      const { data } = await api.post("/auth/refresh_token");
      localStorage.setItem("token", JSON.stringify(data.token));
      api.defaults.headers.Authorization = `Bearer ${data.token}`;
      syncNativeAppAuth(data.token);

      if (window.location.pathname === "/login") {
        window.location.href = "/tickets";
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error("[Auth] Error restaurando sesión nativa:", err);
      localStorage.removeItem("token");
    }
  };
};

export const notifyNativeAppLogin = (jwtToken) => {
  if (!jwtToken) {
    return;
  }

  if (!postMessageToNativeApp(`login${jwtToken}`)) {
    console.warn("[FCM] Bridge nativo no disponible (appInterface / webkit)");
    return;
  }

  console.log("[FCM] Login notificado a app nativa");
};

export const syncNativeAppAuth = (jwtToken) => {
  setupNativeAppBridge();
  notifyNativeAppLogin(jwtToken);
};
